
(function (global) {

  /**
  * Функции реализующие логику страниц
  * @namespace Core.pages
  * @since 5.2.0.1200
  */
  global.pages = {}
})(window.Core);